import { useField } from '@rocketseat/unform';
import React from 'react';

import { Button, TextField, WrapperFlex } from '@unimed-fesp/components';

import {
  CardFilter,
  CardFilterContent,
  CardFilterFooter,
  CardFilterHeader,
} from '../../molecules/CardFilter';
import DatePicker from '../../molecules/DatePicker';
import LabelContainer from '../../molecules/LabelContainer';

import { ComboDatePicker, Container } from './styles';

function FilterExtendsMassaInicial({
  isOpen,
  handleLimparFiltros,
  filters,
  setFilters,
}) {
  const registerCnpj = useField('cnpj').registerField;
  const registerResponsavel = useField('nomeResponsavel').registerField;
  const registerEmail = useField('email').registerField;

  function handleChange({ target }) {
    const { name, value } = target;
    setFilters((oldFilters) => ({ ...oldFilters, [name]: value }));
  }
  function handleData(value, name) {
    if (value.target) return;
    setFilters((oldFilters) => ({
      ...oldFilters,
      [name]: value,
    }));
  }
  return (
    <Container isOpen={isOpen}>
      <CardFilter>
        <CardFilterHeader>filtro avançado</CardFilterHeader>
        <CardFilterContent minHeight="184">
          <WrapperFlex flexWrap justifyStart>
            <TextField
              name="cnpj"
              width={300}
              height={46}
              marginBottom={6}
              labelText="CNPJ"
              value={filters.cnpj}
              placeholder="Pesquise pelo cnpj da empresa"
              font="13px 'Calibri Regular'"
              onChange={(e) => {
                handleChange(e);
              }}
              masked="cnpj"
              register={registerCnpj}
            />
            <TextField
              name="nomeResponsavel"
              width={300}
              height={46}
              marginBottom={6}
              labelText="Responsável"
              value={filters.nomeResponsavel}
              placeholder="Pesquise pelo nome do responsável da empresa"
              font="13px 'Calibri Regular'"
              onChange={(e) => {
                handleChange(e);
              }}
              register={registerResponsavel}
            />
            <TextField
              name="email"
              width={300}
              height={46}
              marginBottom={6}
              labelText="E-mail"
              value={filters.email}
              placeholder="Pesquise pelo E-mail do responsavel da empresa"
              font="13px 'Calibri Regular'"
              onChange={(e) => {
                handleChange(e);
              }}
              register={registerEmail}
            />
            <LabelContainer marginBottom="6" text="Data de registro">
              <ComboDatePicker>
                <DatePicker
                  name="dataRegistroDe"
                  onChange={(e) => handleData(e, 'dataRegistroDe')}
                  value={filters.dataRegistroDe}
                />
                <p>à</p>
                <DatePicker
                  name="dataRegistroAte"
                  onChange={(e) => handleData(e, 'dataRegistroAte')}
                  value={filters.dataRegistroAte}
                />
              </ComboDatePicker>
            </LabelContainer>
          </WrapperFlex>
        </CardFilterContent>
        <CardFilterFooter justifyContent="left">
          <Button
            tipo="primary"
            paddingTop={8}
            paddingBottom={8}
            paddingLeft={8}
            paddingRight={8}
            justifyCenter
            alignCenter
            type="submit"
            font="16px unimed_slabregular"
            width={100}
          >
            pesquisar
          </Button>
          <Button
            tipo="tertiary"
            paddingTop={8}
            paddingBottom={8}
            paddingLeft={8}
            paddingRight={8}
            justifyCenter
            alignCenter
            type="button"
            onClick={handleLimparFiltros}
            font="16px unimed_slabregular"
            width={100}
          >
            limpar
          </Button>
        </CardFilterFooter>
      </CardFilter>
    </Container>
  );
}

export default FilterExtendsMassaInicial;
